import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { BoxV2 as Box, Flex, SxProps } from 'portal-commons';

export interface ContentBlockHeaderProps {
  title: string;
  subTitle?: string;
  icon?: IconDefinition;
  onEdit?: () => void;
  editable?: boolean;
  rightAction?: React.ReactNode;
  titleRowSx?: SxProps;
  sx?: SxProps;
}

const ContentBlockHeader: React.FC<ContentBlockHeaderProps> = ({
  title,
  subTitle,
  icon,
  onEdit,
  editable = false,
  rightAction,
  titleRowSx,
  sx,
}) => {
  return (
    <Flex sx={{ flexDirection: 'column', width: '100%', mb: '12px', ...sx }}>
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          mb: subTitle ? '8px' : '0',
          ...titleRowSx,
        }}
      >
        <Flex sx={{ alignItems: 'center', gap: 'xs', flexGrow: 1 }}>
          {icon && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#4d5659',
                fontSize: '24px',
                height: '24px',
              }}
            >
              <FontAwesomeIcon icon={icon} />
            </Box>
          )}
          <Box
            sx={{
              fontWeight: '600',
              fontSize: '18px',
              color: '#4d5659',
              lineHeight: 'normal',
            }}
          >
            {title}
          </Box>
          {editable && (
            <Flex
              role="button"
              sx={{
                cursor: 'pointer',
                color: '#0091B3',
                alignItems: 'center',
                ml: 8,
                gap: 4,
                fontWeight: 400,
                '&:hover': {
                  opacity: 0.8,
                },
              }}
              onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                e.stopPropagation();
                onEdit?.();
              }}
            >
              <FontAwesomeIcon icon={faPen} fontSize={12} />
              Edit
            </Flex>
          )}
        </Flex>

        {rightAction && <Box sx={{ flexShrink: 0 }}>{rightAction}</Box>}
      </Flex>
      {subTitle && (
        <Box
          sx={{
            fontSize: '14px',
            color: '#4d5659',
            lineHeight: '1.4',
          }}
        >
          {subTitle}
        </Box>
      )}
    </Flex>
  );
};

export default ContentBlockHeader;
